/* ════════════════════════════════════════════════
   Flux Labs — stock rules, SHOPIFY EDITION (2026-10-05)
   Shopify inventory is the ONLY stock source. This file keeps the old
   window.flux* stock API so every page works unchanged, but reads
   availability from the store's own /products.json instead of Supabase.
   • Sold-out = every variant of the product is unavailable in Shopify.
   • Shopify's public data only says available / not available (no counts),
     so there is no "Low stock" state and no cart reservations. Shopify
     checkout itself refuses quantities above what is in stock.
   • Change stock in Shopify admin → Products → Inventory. Nothing else.
════════════════════════════════════════════════ */
(function () {
  var KEY = 'fluxShopAvail';
  var BIG = 999;                                   // "plenty" — any number >= 5 reads as in-stock
  var ALIAS = { 'bac water': 'bacteriostatic water' };

  function norm(s) { return String(s || '').toLowerCase().replace(/\s+/g, ' ').trim(); }
  function canon(s) { var n = norm(s); return ALIAS[n] || n; }
  function loose(s) { return norm(s).replace(/[^a-z0-9,.]/g, ''); }

  // { canonName: [ {title, available}, ... ] }
  var AVAIL = null;
  try { var c = JSON.parse(localStorage.getItem(KEY) || 'null'); if (c && typeof c === 'object') AVAIL = c; } catch (e) {}

  function fireStock() { try { window.dispatchEvent(new CustomEvent('flux:stock')); } catch (e) {} }

  function refresh() {
    return fetch('/products.json?limit=250', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j || !Array.isArray(j.products)) return false;
        var m = {};
        j.products.forEach(function (p) {
          m[canon(p.title)] = (p.variants || []).map(function (v) { return { title: String(v.title || ''), available: !!v.available }; });
        });
        var changed = JSON.stringify(m) !== JSON.stringify(AVAIL);
        AVAIL = m;
        try { localStorage.setItem(KEY, JSON.stringify(m)); } catch (e) {}
        if (changed) fireStock();
        return true;
      }).catch(function () { return false; });
  }

  function variantsOf(name) { return (AVAIL && AVAIL[canon(name)]) || null; }

  // '2×10mg' -> {mult:2,size:'10mg'} ; '10mg' -> {mult:1,size:'10mg'}
  function parseMult(variant) {
    if (!variant) return { mult: 1, size: '' };
    var m = String(variant).match(/^(\d+)\s*[×x]\s*(.+)$/);
    if (m) return { mult: parseInt(m[1], 10) || 1, size: m[2].trim() };
    return { mult: 1, size: String(variant).trim() };
  }

  // find the Shopify variant for a cart/page variant label (null = unknown → don't block)
  function findVariant(vs, label) {
    if (!vs || !vs.length) return null;
    if (vs.length === 1) return vs[0];
    var w = norm(label);
    if (!w) return null;
    return vs.find(function (v) { return norm(v.title) === w; })
        || vs.find(function (v) { return loose(v.title) === loose(w); })
        || vs.find(function (v) { return norm(v.title).indexOf(w) === 0; })
        || vs.find(function (v) { return norm(v.title).indexOf('(' + w + ')') !== -1; })
        || null;
  }

  // single-dose variant for a base size, e.g. '10mg' -> the "10mg" variant
  function findSize(vs, size) {
    if (!vs || !vs.length) return null;
    if (vs.length === 1) return vs[0];
    var w = norm(size);
    if (!w) return null;
    return vs.find(function (v) { return norm(v.title) === w; })
        || vs.find(function (v) { return loose(v.title) === loose(w); })
        || null;
  }

  window.fluxRemote = function () { return false; };
  window.fluxIsMulti = function (name) { var vs = variantsOf(name); return !!(vs && vs.length > 1); };
  window.fluxRefreshStock = refresh;
  window.fluxSyncCart = function () { return Promise.resolve(false); };    // no reservations any more
  window.fluxDecrement = function () {};                                  // Shopify reduces stock at checkout
  window.fluxStockItems = function () { return []; };
  window.fluxSetStock = function () {};
  window.fluxResetStock = function () { refresh(); };

  window.fluxStockStore = function () {
    var out = {};
    if (!AVAIL) return out;
    Object.keys(AVAIL).forEach(function (k) {
      var o = {}; AVAIL[k].forEach(function (v) { o[v.title] = v.available ? BIG : 0; }); out[k] = o;
    });
    return out;
  };

  window.fluxStockOf = function (name, size) {
    var vs = variantsOf(name);
    if (!vs) return Infinity;                                  // not in Shopify's public list → don't block
    var v = (size !== undefined && size !== null && size !== '') ? findSize(vs, size) : null;
    if (v) return v.available ? BIG : 0;
    return vs.some(function (x) { return x.available; }) ? BIG : 0;
  };

  window.fluxStockState = function (name, size) {
    var lim = window.fluxStockOf(name, size);
    if (lim === Infinity) return 'in';
    return lim <= 0 ? 'out' : 'in';
  };

  window.fluxCartQtyOf = function () { return 0; };

  // can this cart line be added? Only blocks when Shopify says that exact variant is unavailable.
  window.fluxCanAddVariant = function (name, variant) {
    var vs = variantsOf(name);
    if (!vs) return true;
    var v = findVariant(vs, variant) || findVariant(vs, parseMult(variant).size);
    return v ? v.available : true;
  };
  window.fluxCanAdd = function (name) { return window.fluxStockOf(name) !== 0; };

  /* ── Sold-out display on every product card (collections, search, etc.) ──
     A size pill whose Shopify variant is unavailable is struck through and the
     card's button becomes "Sold out" when the selected size is unavailable, so
     nobody reaches checkout with something we can't ship. Idempotent: it only
     writes when something changes, so the MutationObserver can't loop. */
  function setOut(el, out) {
    if (!el) return;
    if (el.classList.contains('flux-out') === out) return;
    el.classList.toggle('flux-out', out);
    el.style.opacity = out ? '.45' : '';
    el.style.textDecoration = out ? 'line-through' : '';
    el.style.cursor = out ? 'not-allowed' : '';
    if (out) el.setAttribute('title', 'Sold out'); else el.removeAttribute('title');
  }
  function setBtn(btn, out) {
    if (!btn) return;
    if (btn.dataset.fluxLabel === undefined) {
      if (btn.classList.contains('sold-out-btn')) return;       // "Coming soon" etc. — not ours
      btn.dataset.fluxLabel = btn.textContent;
    }
    if (out) {
      if (btn.textContent !== 'Sold out') btn.textContent = 'Sold out';
      if (!btn.disabled) btn.disabled = true;
      btn.style.opacity = '.55'; btn.style.cursor = 'not-allowed';
    } else {
      if (btn.textContent !== btn.dataset.fluxLabel) btn.textContent = btn.dataset.fluxLabel;
      if (btn.disabled) btn.disabled = false;
      btn.style.opacity = ''; btn.style.cursor = '';
    }
  }
  function pillSize(p) {
    var s = p.dataset && p.dataset.size;
    if (s) return s;
    var l = p.querySelector('.vpill-label');
    return (l ? l.textContent : p.textContent).trim();
  }
  function applyCardStock() {
    if (!AVAIL) return;
    document.querySelectorAll('.product-card').forEach(function (card) {
      var nameEl = card.querySelector('.product-name'); if (!nameEl) return;
      var name = nameEl.textContent.trim();
      var pills = [].slice.call(card.querySelectorAll('.vpill'));
      var active = null;
      pills.forEach(function (p) {
        setOut(p, window.fluxStockState(name, pillSize(p)) === 'out');
        if (p.classList.contains('active')) active = p;
      });
      var out = active ? window.fluxStockState(name, pillSize(active)) === 'out' : window.fluxStockState(name) === 'out';
      card.classList.toggle('flux-card-out', out);
      setBtn(card.querySelector('.add-to-cart'), out);
    });
  }
  function applyPageStock() {
    if (!AVAIL) return;
    var t = document.querySelector('#productRoot h1.pd-title'); if (!t) return;
    var name = t.textContent.trim().replace(/\s+[\d.,]+\s*(mg|mcg|iu|ml)$/i, '');   // pen titles end in their size
    document.querySelectorAll('#productRoot .pd-pill').forEach(function (p) {
      var l = p.querySelector('.pd-pill-label'); if (!l) return;
      setOut(p, window.fluxStockState(name, l.textContent.trim()) === 'out');
    });
    document.querySelectorAll('#productRoot .pd-dose-chip').forEach(function (c) {   // pen size links
      setOut(c, window.fluxStockState(name, c.textContent.trim()) === 'out');
    });
  }
  var cardTimer = null;
  function scheduleCards() { clearTimeout(cardTimer); cardTimer = setTimeout(function () { applyCardStock(); applyPageStock(); }, 60); }
  window.fluxApplyCardStock = applyCardStock;
  window.addEventListener('flux:stock', scheduleCards);
  document.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('.vpill')) setTimeout(applyCardStock, 30); }, true);
  document.addEventListener('DOMContentLoaded', function () {
    applyCardStock();
    try { new MutationObserver(scheduleCards).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
  });

  /* ── Cart panel shipping line ──
     Checkout charges 50 AED for Abu Dhabi and 80 AED for the other emirates
     (free from 1,500 AED). The cart panel can't know the emirate, so it shows
     the range and a "from" total instead of a flat 50 that later jumps to 80. */
  var FREE_FROM = 1500, SHIP_LOW = 50, SHIP_HIGH = 80;
  function numOf(el) { return el ? (parseInt(String(el.textContent).replace(/[^\d]/g, ''), 10) || 0) : 0; }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function fixCartShipping() {
    var subEl = document.getElementById('cartSubtotal'), shipEl = document.getElementById('cartShipping'), grandEl = document.getElementById('cartGrandTotal');
    if (!subEl || !shipEl || !grandEl) return;
    var sub = numOf(subEl);
    var grandLabel = grandEl.parentElement && grandEl.parentElement.firstElementChild;
    var note = document.getElementById('fluxShipNote');
    if (sub <= 0 || sub >= FREE_FROM) {
      setText(grandLabel, 'Total');
      if (note) note.remove();
      return;
    }
    setText(shipEl, SHIP_LOW + '–' + SHIP_HIGH + ' AED');
    setText(grandLabel, 'Total from');
    setText(grandEl, (sub + SHIP_LOW).toLocaleString() + ' AED');
    if (!note && shipEl.parentElement) {
      note = document.createElement('div');
      note.id = 'fluxShipNote';
      note.style.cssText = 'font-size:12px;color:var(--muted,#8a8a8a);margin:2px 0 6px;text-align:right';
      note.textContent = 'Abu Dhabi ' + SHIP_LOW + ' AED · other emirates ' + SHIP_HIGH + ' AED · exact price at checkout';
      shipEl.parentElement.insertAdjacentElement('afterend', note);
    }
  }
  document.addEventListener('DOMContentLoaded', function () {
    fixCartShipping();
    ['cartSubtotal', 'cartShipping', 'cartGrandTotal'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) try { new MutationObserver(fixCartShipping).observe(el, { childList: true, characterData: true, subtree: true }); } catch (e) {}
    });
    window.addEventListener('flux:cart', function () { setTimeout(fixCartShipping, 0); });
  });

  refresh();
  setInterval(refresh, 60000);
  window.addEventListener('focus', refresh);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
})();
